<template>
    <div class="config">
        <img src="@/assets/images/config.png" width="30" height="30" alt="Configuración" title="Configuración" class="imgconfig img-fluid" @click="loadConfig" />
        <modal
            name="ConfigModal"
            width="80%"
            height="auto"
            :scrollable="true"
            :adaptive="true"
            :clickToClose="false"
            style="overflow:scroll"
        >
            <div class="container">
                <div class="tabcontent">
                    <div class="titlePage">Configuración {{this.nameModule}}</div>
                    <va-notification color="info" v-if="addRExito" class="refNoData">Se genero correctamente la actulizacion del modulo.</va-notification>
                    <va-notification color="danger" v-if="refConfig" class="refNoData">El modulo a configurar no se encuentra activo.</va-notification>
                    <va-notification color="danger" v-if="addRError" class="refNoData">El modulo a configurar no se encuentra activo.</va-notification>
                    <div v-if="moduleConf">
                      <ValidationObserver ref="obsFieldsFiles">
                          <FormConfig :FieldsForm="listFormConfig" :ModelForm="listFormConfigModel" :method="executeProcess" v-if="renderComponent1" />
                      </ValidationObserver>
                    </div>
                </div>
                <div class="botoPnrocess">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-3">
                                <button
                                id="CancelConfig"
                                type="submit"
                                v-on:click="cancelConfig"
                                class="loginbtn primaryBtn primaryBtn"
                                >Cancelar</button>
                            </div>
                            <div class="col-md-6"></div>
                            <div class="col-md-3">
                                <button
                                id="UpdayeConfig"
                                type="submit"
                                v-on:click="updateConfig"
                                class="loginbtn primaryBtn primaryBtn"
                                >Actualizar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'
import FormConfig from '@/components/forms/Forms.vue'

export default {
  name: 'config',
  props: {
    Module: String,
  },
  components: {
    FormConfig,
  },
  data () {
    return {
      renderComponent1: false,
      moduleConf: false,
      addRExito: false,
      addRError: false,
      refConfig: false,
      listFormConfig: [],
      listFormConfigModel: {},
      infoConfig: [],
      nameModule: '',
      dataConf: this.Module,
    }
  },
  methods: {
    cancelConfig () {
      this.renderComponent1 = false
      this.$modal.hide('ConfigModal')
    },
    updateConfig () {
      this.addRExito = false
      this.addRError = false
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsFiles.validate().then(results => {
          if (!results) {
            resolve(false)
          } else {
            var refObject = []
            let loader = this.$loading.show()
            for (var data in this.listFormConfigModel) {
              refObject.push({
                IdConfigForm: data.split('_')[1],
                ValConfigForm: this.listFormConfigModel[data],
              })
            }
            var updConfig = IberoHelpers.updateConfigById(this.$store, refObject)
            updConfig.then(Response => {
              if (Response.data.message === 'Success') {
                this.addRExito = true
                resolve(true)
              } else {
                this.addRError = true
                resolve(false)
              }
            })
            loader.hide()
          }
        })
      })
    },
    setObjectlist (valorum) {
      var DataArray = ''
      var infolist = []
      DataArray = valorum.split('|')
      for (var i = 0; i < DataArray.length; i++) {
        infolist.push(
          { id: DataArray[i], value: DataArray[i] }
        )
      }
      return infolist
    },
    executeProcess: function (event, refer) {
      return true
    },
    loadForm () {
      this.listFormConfig.length = 0
      for (var i = 0; i < this.infoConfig.FormConfig.length; i++) {
        var validateRef = ''
        var validatePicker = {}
        var listData = ''
        var refRegis = 'id_' + this.infoConfig.FormConfig[i].Id_ConfigForm
        var Datplaceholder = this.infoConfig.FormConfig[i].Nam_ConfigForm

        if (this.infoConfig.FormConfig[i].Det_ValidateConfigForm !== '') {
          validateRef = JSON.parse(this.infoConfig.FormConfig[i].Det_ValidateConfigForm)
        }

        if (this.infoConfig.FormConfig[i].Type_ConfigForm === 'radio' || this.infoConfig.FormConfig[i].Type_ConfigForm === 'Select') {
          listData = this.setObjectlist(this.infoConfig.FormConfig[i].Det_DataConfigForm)
          this.listFormConfigModel[refRegis] = this.infoConfig.FormConfig[i].Val_ConfigForm
        } else if (this.infoConfig.FormConfig[i].Type_ConfigForm === 'datepicker') {
          this.listFormConfigModel[refRegis] = ''
          validatePicker.format = this.$store.state.dateFormat
          validatePicker.disabledDates = {
            to: new Date(1900, 0, 1),
            from: new Date(),
          }
        } else if (this.infoConfig.FormConfig[i].Type_ConfigForm === 'title') {
          this.listFormConfigModel[refRegis] = this.infoConfig.FormConfig[i].Nam_ConfigForm
        } else if (this.infoConfig.FormConfig[i].Type_ConfigForm === 'accepted') {
          Datplaceholder = this.infoConfig.FormConfig[i].Det_DataConfigForm
          if (this.infoConfig.FormConfig[i].Sta_AditionalConfigForm) {
            this.listHtml.push({ id: 'cbox_' + refRegis, value: this.infoConfig.FormConfig[i].Det_ConfigForm, show: false })
            Datplaceholder = Datplaceholder.replace('[', '<a class="linkTerm">').replace(']', '</a>')
          }
          listData = 'Si'
        } else if (this.infoConfig.FormConfig[i].Type_ConfigForm === 'check') {
          listData = this.setObjectlist(this.infoConfig.FormConfig[i].Det_DataConfigForm)
          this.listFormConfigModel[refRegis] = []
        } else {
          this.listFormConfigModel[refRegis] = this.infoConfig.FormConfig[i].Val_ConfigForm
        }

        this.listFormConfig.push({
          id: refRegis,
          name: this.infoConfig.FormConfig[i].Nam_ConfigForm,
          type: this.infoConfig.FormConfig[i].Type_ConfigForm,
          class: this.infoConfig.FormConfig[i].Det_DataConfigClass,
          placeholder: Datplaceholder,
          values: listData,
          model: refRegis,
          validate: validateRef,
          dateTimePickerOptions: validatePicker,
          tooltip: this.infoConfig.FormConfig[i].Det_ConfigTooltip,
          disabled: false,
        })
      }
      IberoHelpers.forceRerender1(this)
    },
    loadConfig () {
      this.addRExito = false
      this.addRError = false
      let loader = this.$loading.show()
      var sendMails = IberoHelpers.getConfigModule(this.$store, this.dataConf)
      sendMails.then(Response => {
        if (Response.data) {
          if (Response.data[0].StaConfig) {
            this.nameModule = Response.data[0].NameConfig
            this.infoConfig = Response.data[0]
            this.loadForm()
            this.moduleConf = true
          } else {
            this.refConfig = true
          }
        } else {
          this.refConfig = true
        }
        this.$modal.show('ConfigModal')
        loader.hide()
      })
    },
  },
}
</script>